import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import {
  ButtonModule,
  DrawerModule,
  FlightsModule,
  IconsModule,
  LinkModule,
  ModalModule,
  NotificationsModule,
} from '@fcom/ui-components';
import { UiTranslateModule } from '@fcom/ui-translate';
import { ComponentsModule } from '@fcom/common/components/components.module';
import { GtmModule } from '@fcom/common/gtm/gtm.module';
import { PipesModule } from '@fcom/common/pipes/pipes.module';
import { BookingCommonModule } from '@fcom/booking/modules/common/booking-common.module';
import { DirectiveModule } from '@fcom/common/directives';
import { CmsModule } from '@fcom/cms';

import { AncillaryHeaderComponent } from '../ancillary-header/ancillary-header.component';
import { AncillaryFlightBoundSelectorComponent } from '../flight-bound-selector/ancillary-flight-bound-selector.component';
import { AncillarySubviewComponent } from './ancillary-subview.component';
import { CommonBookingComponentsModule } from '../../../../components';
import { BookingSummaryModule } from '../../../../components/booking-summary/booking-summary.module';
import { SubViewModule } from '../../../../components/subview/subview.module';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    CommonBookingComponentsModule,
    PipesModule,
    GtmModule,
    BookingCommonModule,
    BookingSummaryModule,
    UiTranslateModule,
    ButtonModule,
    IconsModule,
    LinkModule,
    DrawerModule,
    FlightsModule,
    ModalModule,
    NotificationsModule,
    SubViewModule,
    DirectiveModule,
    CmsModule,
  ],
  declarations: [AncillaryFlightBoundSelectorComponent, AncillaryHeaderComponent, AncillarySubviewComponent],
  exports: [AncillarySubviewComponent, AncillaryHeaderComponent, AncillaryFlightBoundSelectorComponent],
})
export class AncillarySubviewModule {}
